import { Dialog } from './modal';

const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));

const keyCode = Object.freeze({
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
});

class GenericAutoComplete {
    constructor(domNode) {
        this.domNode = domNode;
        this.formNode = this.domNode.querySelector('.header-search-form');
        this.inputContainerNode = this.domNode.querySelector(
            '.auto-complete-container'
        );
        this.inputNode = this.domNode.querySelector('#generic-search-input');
        // this.submitNode = this.domNode.querySelector('.js-button-go');
        this.clearInputNode = this.domNode.querySelector('.js-button-reset');
        this.resultContainerNode = this.domNode.querySelector('#ac-lookups');
        this.resultNode = this.resultContainerNode.querySelector(
            '.search-results-inner'
        );
        this.popSuggestNode = this.domNode.querySelector('.popular-suggests');
        this.liveNode = this.domNode.querySelector('[aria-live]');

        this.centreId = this.inputNode.dataset.centreid;

        this.tplResultItem = document.getElementById('headerSearchResultItem')
            ? document.getElementById('headerSearchResultItem').content
            : null;
        this.tplResultCount = document.getElementById('headerSearchResultCount')
            ? document.getElementById('headerSearchResultCount').content
            : null;

        this.inputValue = this.inputNode.value;
        this.results = [];
        this.selectedIndex = -1;
    }

    initAnimation() {
        if (!this.inputValue || this.inputValue.length < 3) {
            const headerSearchModal = document.querySelector('#header-search');
            const observer = new MutationObserver(mutationCallback.bind(this));
            observer.observe(headerSearchModal, {
                attributes: true,
                attributeFilter: ['class'],
                childList: false,
                characterData: false,
            });
            function mutationCallback() {
                if (headerSearchModal.classList.contains('is-visible')) {
                    delay(750).then(() => {
                        this.inputContainerNode.classList.add('search-open');
                        this.resultNode.innerHTML = '';
                        this.popSuggestNode.removeAttribute('hidden');
                        this.resultContainerNode.style.height =
                            // Note: the "1" number is added to remove the scroll bar in the browser
                            this.resultContainerNode.scrollHeight + 1 + 'px';
                    });
                    observer.disconnect();
                }
            }
        }
    }

    init() {
        this.inputNode.addEventListener('change', this.handleChange.bind(this));
        this.inputNode.addEventListener('keyup', this.handleKeyup.bind(this));
        this.clearInputNode.addEventListener(
            'click',
            this.handleClearClick.bind(this)
        );
    }

    debounce(func, wait) {
        let timeout;
        return function () {
            if (!timeout) func.apply(this, arguments);
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
            }, wait);
        };
    }

    buildListHTML(ajaxResults, ajaxTotal) {
        this.resultNode.innerHTML = '';

        // build result item list
        ajaxResults.slice(0, 5).forEach((item) => {
            const resultItemEl = this.tplResultItem.cloneNode(true);
            const itemLinkElem = resultItemEl.querySelector('a');
            const itemTitleElem = resultItemEl.querySelector('.title-text');
            const itemDesciptionElem =
                resultItemEl.querySelector('.description-text');

            itemLinkElem.href = item.url;
            itemLinkElem.title = item.pagetitle;
            itemTitleElem.innerHTML = item.pagetitle.replace(
                new RegExp(this.inputValue, 'gi'),
                (str) => `<span class='highlight'>${str}</span>`
            );
            if (item.description) {
                itemDesciptionElem.innerHTML = item.description.replace(
                    new RegExp(this.inputValue, 'gi'),
                    (str) => `<span class='highlight'>${str}</span>`
                );
            }

            // resultItemEl.setAttribute('aria-selected', 'false');
            // resultItemEl.tabIndex = -1;
            this.resultNode.append(resultItemEl);
        });

        // build results count
        const resultCountEl = this.tplResultCount.cloneNode(true);
        if (ajaxTotal > 5) {
            resultCountEl.querySelector('.count-text').innerHTML =
                this.resultNode.dataset.format.replace('{count}', ajaxTotal);
            resultCountEl.querySelector('.js-view-all-results').style.display =
                'inline-flex';
            resultCountEl.querySelector('.js-view-all-results').onclick =
                function (e) {
                    e.preventDefault();
                    this.formNode.submit();
                }.bind(this);
        } else {
            resultCountEl.querySelector('.count-text').innerHTML =
                'There are no more results for your search.';
            resultCountEl.querySelector('.js-view-all-results').style.display =
                'none';
        }
        this.resultNode.append(resultCountEl);

        this.showResults();
    }

    showResults() {
        // this.submitNode.disabled = false;
        this.inputContainerNode.classList.add('search-open');
        this.popSuggestNode.setAttribute('hidden', '');
        this.resultContainerNode.style.height = 'auto';
    }

    closeResults() {
        // this.submitNode.disabled = true;
        this.inputContainerNode.classList.add('search-open');
        this.resultNode.innerHTML = '';
        this.popSuggestNode.removeAttribute('hidden');
        this.resultContainerNode.style.height = 'auto';
    }

    showNoResultsMsg() {
        // this.submitNode.disabled = true;
        this.inputContainerNode.classList.add('search-open');
        this.resultNode.innerHTML = '';

        const icon = document.createElement('i');
        icon.classList.add('icon', 'icon-search-error', 'header-search-error');

        const text = document.createElement('span');
        text.innerHTML =
            this.resultContainerNode.getAttribute('data-noresult-text');

        const msgEl = document.createElement('p');
        msgEl.classList.add('p-18', 'semibold', 'title-text', 'no-results');
        msgEl.appendChild(icon);
        msgEl.appendChild(text);

        const resItemEl = document.createElement('div');
        resItemEl.classList.add('result-item');
        resItemEl.appendChild(msgEl);

        this.resultNode.appendChild(resItemEl);

        this.popSuggestNode.removeAttribute('hidden');
        this.resultContainerNode.style.height = 'auto';
    }

    announceResults() {
        let number = this.results.length,
            textToRead =
                number + ' results are available. ' + this.instructionText;

        if (number === 0) {
            textToRead = 'No search results';
        }

        this.liveNode.innerHTML = textToRead;
        setTimeout(
            function () {
                this.liveNode.innerHTML = '';
            }.bind(this),
            1000
        );
    }

    autocomplete() {
        if (this.inputNode.value === this.inputValue) {
            return;
        }
        this.inputValue = this.inputNode.value;

        // this.submitNode.disabled = true;
        // this.clearInputNode.disabled = !this.inputValue;

        if (this.inputValue.length >= 3) {
            fetch(
                `/assets/components/livewelldorset/genericSearch.php?term=${this.inputValue}&centreId=${this.centreId}`
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.results.length === 0) {
                        this.showNoResultsMsg();
                    } else {
                        this.buildListHTML(data.results, data.total);
                        this.results =
                            this.resultNode.querySelectorAll('.result-item');
                    }
                    this.announceResults();
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            this.closeResults();
        }
    }

    handleChange(event) {
        this.debounce(this.autocomplete(), 200);
    }

    handleKeyup(event) {
        const pressedCode = event.keyCode;

        if (
            pressedCode === keyCode.TAB ||
            pressedCode === keyCode.RETURN ||
            pressedCode === keyCode.UP ||
            pressedCode === keyCode.DOWN ||
            pressedCode === keyCode.ESC
        ) {
            return;
        }
        this.debounce(this.autocomplete(), 200);
    }

    closeAutoComplete() {
        // this.clearInputNode.disabled = true;
        // this.submitNode.disabled = true;
        this.inputNode.value = '';
        this.inputValue = '';
        this.inputContainerNode.classList.remove('search-open');
        this.resultNode.innerHTML = '';
        this.popSuggestNode.removeAttribute('hidden');
        this.resultContainerNode.style.height = 0;
    }

    handleClearClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.closeAutoComplete();
    }
}

const headerSearchContrEls = document.querySelectorAll('.js-nav-search');
if (headerSearchContrEls.length) {
    const modalSearch = new GenericAutoComplete(
        document.querySelector('#headerSearchModal')
    );
    modalSearch.init();

    const initDialog = (modalContr) => {
        const targetModalId = modalContr.dataset.target;

        modalContr.addEventListener('click', function (eve) {
            eve.preventDefault();

            modalSearch.initAnimation();
            let targetModalObj = new Dialog(
                targetModalId,
                this,
                null,
                false,
                function () {
                    modalSearch.closeAutoComplete();
                }
            );
            modalSearch.clearInputNode.onclick = function () {
                targetModalObj.getOpenDialog.close();
            };
            document.onkeyup = function (event) {
                const keyCode = event.which || event.keyCode;
                if (keyCode === 27) {
                    event.stopPropagation();
                    targetModalObj.getOpenDialog.close();
                    modalSearch.closeAutoComplete();
                }
            };
        });
    };

    for (const modalContr of headerSearchContrEls) {
        initDialog(modalContr);
    }
}
